/**
 * 图标公共组件
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-04-19 16:38:19
 * @LastEditTime: 2021-04-20 10:20:17
 * @FilePath: \buyer-one\dop-webapp\src\components\IconFont\index.js
 * @Copyright: Copyright 2021-2021, all rights reserved. Essa.cn
 */

import { createFromIconfontCN } from "@ant-design/icons";
import "@assets/fonts/iconfont/iconfont.js";

// 当前环境
const isProduction = process.env.NODE_ENV === "production";

// 创建组件
const IconFont = createFromIconfontCN({
    // scriptUrl: [
    //     // 根据环境选择图标文件加载路径
    //     isProduction
    //         ? "/public/dop/static/js/iconfont.js"
    //         : "/static/js/iconfont.js",
    // ],
    scriptUrl: [   "/static/js/iconfont.js", ], // 现只有一个加载路径
});

export default IconFont;
